export const dashboardWidgets = {
  upcoming: {
    title: "Bevorstehende Anreisen",
    empty: "Keine bevorstehenden Ereignisse",
    createBooking: "Buchung anlegen",
  },
  lastActivity: {
    title: "Letzte Aktivität",
  },
  portals: {
    title: "Synchronisierte Buchungskanäle",
    connectedSuccess: "Erfolgreich verbunden",
    unknownChannel: "Unbekannt",
    connectNewChannel: "Neuen Kanal verbinden",
    empty: "Sie haben keine synchronisierten Kanäle",
    connectChannel: "Kanal verbinden",
    loadError: "Die Portale konnten nicht geladen werden",
    errorTitle: "Fehler",
  },
};
